<template>
  <v-chip-group v-model="valueInput" color="primary" column mandatory>
    <v-chip
      filter
      v-for="(value, key) in _worksheetStatusAllObj"
      :value="key"
      :color="worksheetStatusCardColor(key)"
      outlined
      :key="key"
    >
      <span class="px-1">{{ value }}</span>
    </v-chip>
  </v-chip-group>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "WorksheetFilterStatus",
  mounted() {
    this.getParamQuery();
  },
  props: {
    value: {},
  },
  data: () => ({
    queryOrder: {
      status: "status",
    },
    settingValue: "all",
  }),
  methods: {
    getParamQuery() {
      Object.keys(this.queryOrder).forEach((key) => {
        if (!_.isNil(this.$route.query[key])) {
          switch (key) {
            case "status":
              this.settingValue = this.$route.query[key];
          }
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      worksheetStatusCardColor: "worksheet/worksheetStatusCardColor",
    }),
    _worksheetStatusAllObj: function () {
      return this.$store.state.worksheet.worksheetStatusAllText;
    },
    valueInput: {
      get() {
        return this.settingValue;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style scoped></style>
